import api from '../Services/AxiosInstance';


export class DocumentService {
  getDocumentByPeriod9 = async (typedoc, period, dateDeb, dateFin) => {
    try {
      const response = await api.get(`/Document/Dashboard/list/${typedoc}/${period}?dateDeb=${dateDeb}&dateFin=${dateFin}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);

    }
  };

  getAllDocumentByPeriod = async (typedoc, period) => {
    try {
      const response = await api.get(`/Document/Dashboard/list/${typedoc}/${period}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);

    }
  };

  getAnomaliesTraitementFacture = async (numFact) => {
    try {
      const response = await api.get(`/Document/AnomaliesTraitementFacture`, { params: { numFact } });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
    }
  };

  getOrdonnanceUrl = async (numdoc) => {
    try {
      const response = await api.get(`/Document/getOrdonnance/${numdoc}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
    }
  };
}